/**
* @file Column component for displaying spendtime values.
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { LocalisationService } from '../../../core/localisation.service';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Column component for displaying a spend time value
 */
var ColumnSpendtimeContextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnSpendtimeContextComponent, _super);
    /**
     * Constructs a ColumnSpendtimeComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnSpendtimeContextComponent(provider, changeDetector, localisationService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.localisationService = localisationService;
        _this.entity = _this.provider.entity;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnSpendtimeContextComponent.register = function () {
        ComponentRegistry.register('column', 'spendtime-context', ColumnSpendtimeContextComponent);
    };
    /**
     * Create a summary by adding the next part to the previous (prefix).
     * Get the next property value in the range and add that to the given prefix.
     * @param prefix The first part of the result, the part that is appended to.
     * @param propertyName The property name to add to the prefix.
     * @param paths The paths to find the property. If there are multiple,
     * get the first in the given order, that returns a non-empty result.
     */
    ColumnSpendtimeContextComponent.prototype.getNextPropertyValue = function (prefix, propertyName) {
        var paths = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            paths[_i - 2] = arguments[_i];
        }
        var result = prefix;
        paths.forEach(function (path) {
            // Multiple paths may be given, add just one (the first non-empty one).
            if (path && path[propertyName] && path[propertyName].trim() !== '' && result === prefix) {
                if (prefix) {
                    result = result + ', ';
                }
                result = result + path[propertyName];
            }
        });
        return result;
    };
    /**
     * Get the full name of the customer using getNextPropertyValue
     */
    ColumnSpendtimeContextComponent.prototype.getCustomerFullName = function (path1, path2, path3, path4) {
        if (path3 === void 0) { path3 = null; }
        if (path4 === void 0) { path4 = null; }
        var result = this.getNextPropertyValue('', 'FirstName', path1, path2, path3, path4) + ' ' +
            this.getNextPropertyValue('', 'Prefix', path1, path2, path3, path4) + ' ' +
            this.getNextPropertyValue('', 'Name', path1, path2, path3, path4);
        if (result.trim() !== '') {
            result = ', ' + result.replace(',', '');
            result = result.replace(/  +/g, ' ');
        }
        return result;
    };
    /**
     * Create human-readable presentation of the summary.
     * The summary must contain the names of several objects (see comments below).
     */
    ColumnSpendtimeContextComponent.prototype.generateSummary = function () {
        var result = '';
        var account = this.entity.Account;
        var project = null;
        var customer = null;
        if (account) {
            switch (this.entity.AccountClass) {
                case 'ASSIGNMENT':
                case 'APPOINTMENT':
                    // Return Assignment, Task, Project, Customer.
                    var task = account.Deployment && account.Deployment.Demand ? account.Deployment.Demand.Task : null;
                    project = task ? task.Project : null;
                    customer = project == null ? null : project.Customer;
                    result = this.getNextPropertyValue(result, 'Name', account);
                    result = this.getNextPropertyValue(result, 'Name', task);
                    result = this.getNextPropertyValue(result, 'Name', project);
                    result += this.getCustomerFullName(this.entity.Customer, account.Customer, task ? task.Customer : null, customer);
                    break;
                case 'ABSENCE':
                    // Return Appointment.
                    result = this.getNextPropertyValue(result, 'Name', account);
                    break;
                case 'TASK':
                    // Return Task, Project, Customer.
                    project = account.Project;
                    customer = project == null ? null : project.Customer;
                    result = this.getNextPropertyValue(result, 'Name', account);
                    result = this.getNextPropertyValue(result, 'Name', project);
                    result += this.getCustomerFullName(this.entity.Customer, account.Customer, customer);
                    break;
                case 'PROJECT':
                    // Return Project, Customer.
                    result = this.getNextPropertyValue(result, 'Name', account);
                    result += this.getCustomerFullName(this.entity.Customer, account.Customer);
                    break;
                case 'ATTENDANT':
                    // Returns Shift Service Attendant
                    var service = account.Service;
                    var shift = service ? service.Shift : null;
                    result = this.getNextPropertyValue(result, 'Name', account);
                    result = this.getNextPropertyValue(result, 'Name', service);
                    result = this.getNextPropertyValue(result, 'Name', shift);
                    break;
            }
        }
        return result;
    };
    return ColumnSpendtimeContextComponent;
}(ColumnBase));
export { ColumnSpendtimeContextComponent };
